export const PAGES_URLS = {
  Loyalty: '/loyalty',
  Profiles: '/profiles',
  HotelReservations: '/room-reservations',
  VenueReservations: '/venue-reservations',
  AppSettings: '/app-settings',
} as const;
